const projectCardList = document.querySelector('.project-card-list');
if (projectCardList) {
  const categoryDropdowns = projectCardList.querySelectorAll('.dropdown');
  categoryDropdowns.forEach((item) => {
    item.addEventListener("change", (event) => {
      const formDataInput = new FormData();
      const formData = {};
      categoryDropdowns.forEach((categoryDropdown) => {
        const input = categoryDropdown.querySelector('input:checked');
        if (input){
          formData[input.name] = input.id.trim();
        }
      });
      const categories = document.querySelector('.project-categories');
      if(categories) {
        formData.categories = categories.getAttribute('data-categories') || '';
      }

      formDataInput.append('action', 'getProjectCards');
      formDataInput.append('id', localData.id);
      formDataInput.append('lang', localData.lang);
      formDataInput.append('inputs', JSON.stringify(formData));
      axios
        .post(localData.siteURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const projectCardListInner = projectCardList.querySelector('.project-card-list__inner');
            const projectCardListNoResults = projectCardList.querySelector('.no-results');
            if (response.data.data.newProjectsHTML) {
              projectCardListInner.innerHTML = response.data.data.newProjectsHTML;
              projectCardListNoResults.style.display = 'none';
            } else {
              projectCardListNoResults.style.display = 'block';
              projectCardListInner.innerHTML = '';
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  });
}
